import { render } from "./ChildCreationPage.vue?vue&type=template&id=3243e358"
import script from "./ChildCreationPage.vue?vue&type=script&lang=js"
export * from "./ChildCreationPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__